"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
// This file is derived from coinbase-wallet-sdk/packages/wallet-sdk/src/provider/CoinbaseWalletProvider.ts (2022/08/01).
// Modified for the klip-web3-provider development.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlipWeb3Provider = void 0;
const { prepare, getResult } = require('klip-sdk');
const safe_event_emitter_1 = __importDefault(require("@metamask/safe-event-emitter"));
const utils_1 = require("@walletconnect/utils");
const eth_rpc_errors_1 = require("eth-rpc-errors");
const caver_js_1 = __importDefault(require("caver-js"));
const klip_qrcode_modal_1 = __importDefault(require("./klip-qrcode-modal"));
const JSONRPC_1 = require("./JSONRPC");
const SubscriptionManager_1 = require("./SubscriptionManager");
const CypressChainId = '0x2019';
const ErrorMsgCaverUndefined = 'RPC Url is not provided or chain id is different from Klaytn Mainnet.';
const KlipUrl = 'https://klipwallet.com/?target=/a2a?request_key=';
class KlipWeb3Provider extends safe_event_emitter_1.default {
    constructor(opts) {
        super({});
        this.qrcode = true;
        this.chainId = '';
        this.qrcodeModal = klip_qrcode_modal_1.default;
        this.qrcodeModalOptions = undefined;
        this.bappName = '';
        this.rpcUrl = '';
        this.caverEnabled = false;
        this._subscriptionManager = new SubscriptionManager_1.SubscriptionManager(this);
        this._addresses = [];
        this._send = this.send.bind(this);
        this._sendAsync = this.sendAsync.bind(this);
        this.enable = () => __awaiter(this, void 0, void 0, function* () {
            if (this.caver != undefined) {
                this.caverEnabled = yield this._checkRpcUrl();
            }
            if (this._addresses.length > 0) {
                return this._addresses;
            }
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const res = yield prepare.auth({ bappName: this.bappName });
                if (res.err) {
                    return reject(res.err);
                }
                else if (res.request_key) {
                    const klipLink = KlipUrl + res.request_key;
                    this.qrcodeModal.open(klipLink, () => {
                        this.emit('modal_closed');
                    });
                    const interval = setInterval(() => {
                        getResult(res.request_key).then((data) => {
                            if (data.status == 'completed') {
                                this.qrcodeModal.close();
                                clearInterval(interval);
                                this._addresses = [data.result.klaytn_address];
                                return resolve([data.result.klaytn_address]);
                            }
                            else if (data.status == 'canceled' || data.status == 'error') {
                                this.qrcodeModal.close();
                                clearInterval(interval);
                                this._addresses = [];
                                return reject(new Error('Process is canceled or error occurs'));
                            }
                        });
                    }, 1000);
                    this.on('modal_closed', () => {
                        clearInterval(interval);
                        return reject(new Error('QRCode modal is closed!'));
                    });
                }
            }));
        });
        this.bappName = opts.bappName ? opts.bappName : 'undefined';
        this.rpcUrl = opts.rpcUrl ? opts.rpcUrl : 'undefined';
        this.caver = this.rpcUrl != 'undefined' ? new caver_js_1.default(new caver_js_1.default.providers.HttpProvider(this.rpcUrl)) : undefined;
        this.chainId = this.getChainId();
        this._subscriptionManager.events.on('notification', (notification) => {
            this.emit('message', {
                type: notification.method,
                data: notification.params,
            });
        });
    }
    _checkRpcUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = yield this.caver.rpc.klay.getChainId();
            return chainId === CypressChainId;
        });
    }
    getChainId() {
        return CypressChainId;
    }
    get connected() {
        return true;
    }
    supportsSubscriptions() {
        return false;
    }
    disconnect() {
        return true;
    }
    send(requestOrMethod, callbackOrParams) {
        // send<T>(method, params): Promise<T>
        if (typeof requestOrMethod === 'string') {
            const method = requestOrMethod;
            const params = Array.isArray(callbackOrParams)
                ? callbackOrParams
                : callbackOrParams !== undefined
                    ? [callbackOrParams]
                    : [];
            const request = {
                jsonrpc: '2.0',
                id: 0,
                method,
                params,
            };
            return this._sendRequestAsync(request).then((res) => res.result);
        }
        // send(JSONRPCRequest | JSONRPCRequest[], callback): void
        if (typeof callbackOrParams === 'function') {
            const request = requestOrMethod;
            const callback = callbackOrParams;
            return this._sendAsync(request, callback);
        }
        // send(JSONRPCRequest[]): JSONRPCResponse[]
        if (Array.isArray(requestOrMethod)) {
            const requests = requestOrMethod;
            return requests.map((r) => this._sendRequest(r));
        }
        // send(JSONRPCRequest): JSONRPCResponse
        const req = requestOrMethod;
        return this._sendRequest(req);
    }
    sendAsync(request, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof callback !== 'function') {
                throw new Error('callback is required');
            }
            // send(JSONRPCRequest[], callback): void
            if (Array.isArray(request)) {
                const arrayCb = callback;
                this._sendMultipleRequestsAsync(request)
                    .then((responses) => arrayCb(null, responses))
                    .catch((err) => arrayCb(err, null));
                return;
            }
            // send(JSONRPCRequest, callback): void
            const cb = callback;
            return this._sendRequestAsync(request)
                .then((response) => cb(null, response))
                .catch((err) => cb(err, null));
        });
    }
    request(args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!args || typeof args !== 'object' || Array.isArray(args)) {
                throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
                    message: 'Expected a single, non-array, object argument.',
                    data: args,
                });
            }
            const { method, params } = args;
            if (typeof method !== 'string' || method.length === 0) {
                throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
                    message: "'args.method' must be a non-empty string.",
                    data: args,
                });
            }
            if (params !== undefined && !Array.isArray(params) && (typeof params !== 'object' || params === null)) {
                throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
                    message: "'args.params' must be an object or array if provided.",
                    data: args,
                });
            }
            const newParams = params === undefined ? [] : params;
            const res = yield this._sendRequestAsync({
                method,
                params: newParams,
                jsonrpc: '2.0',
                id: 0,
            });
            return res.result;
        });
    }
    _sendRequest(request) {
        const response = {
            jsonrpc: '2.0',
            id: request.id,
        };
        const { method } = request;
        response.result = this._handleSynchronousMethods(request);
        if (response.result === undefined) {
            throw new Error(`Kaikas Wallet does not support calling ${method} synchronously without ` +
                `a callback. Please provide a callback parameter to call ${method} ` +
                `asynchronously.`);
        }
        return response;
    }
    _sendRequestAsync(request) {
        return new Promise((resolve, reject) => {
            try {
                const syncResult = this._handleSynchronousMethods(request);
                if (syncResult !== undefined) {
                    return resolve({
                        jsonrpc: '2.0',
                        id: request.id,
                        result: syncResult,
                    });
                }
                const subscriptionPromise = this._handleSubscriptionMethods(request);
                if (subscriptionPromise !== undefined) {
                    subscriptionPromise
                        .then((res) => resolve({
                        jsonrpc: '2.0',
                        id: request.id,
                        result: res.result,
                    }))
                        .catch((err) => reject(err));
                    return;
                }
            }
            catch (err) {
                return reject(err);
            }
            this._handleAsynchronousMethods(request)
                .then((res) => res && resolve(Object.assign(Object.assign({}, res), { id: request.id })))
                .catch((err) => reject(err));
        });
    }
    _handleSubscriptionMethods(request) {
        switch (request.method) {
            case JSONRPC_1.JSONRPCMethod.eth_subscribe:
            case JSONRPC_1.JSONRPCMethod.eth_unsubscribe:
                return this._subscriptionManager.handleRequest(request);
        }
        return undefined;
    }
    _sendMultipleRequestsAsync(requests) {
        return Promise.all(requests.map((r) => this._sendRequestAsync(r)));
    }
    _handleSynchronousMethods(request) {
        const { method } = request;
        switch (method) {
            case JSONRPC_1.JSONRPCMethod.eth_accounts:
                return this._eth_accounts();
            case JSONRPC_1.JSONRPCMethod.net_version:
                return this._net_version();
            case JSONRPC_1.JSONRPCMethod.eth_chainId:
                return this._eth_chainId();
            default:
                return undefined;
        }
    }
    _handleAsynchronousMethods(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { method } = request;
            const params = request.params || [];
            switch (method) {
                case JSONRPC_1.JSONRPCMethod.personal_sign:
                    return this._personal_sign(params);
                case JSONRPC_1.JSONRPCMethod.eth_sendTransaction:
                    return this._eth_sendTransaction(params);
                case JSONRPC_1.JSONRPCMethod.personal_ecRecover:
                    return this._personal_ecRecover(params);
                case JSONRPC_1.JSONRPCMethod.eth_blockNumber:
                    return this._eth_blockNumber();
                case JSONRPC_1.JSONRPCMethod.eth_getBlockByNumber:
                    return this._eth_getBlockByNumber(params);
                case JSONRPC_1.JSONRPCMethod.eth_getGasPrice:
                    return this._eth_getGasPrice();
                case JSONRPC_1.JSONRPCMethod.eth_getTransactionReceipt:
                    return this._eth_getTransactionReceipt(params);
                case JSONRPC_1.JSONRPCMethod.eth_call:
                    return this._eth_call(params);
            }
            throw new Error(`${method} is not supported in klip-web3-provider.`);
        });
    }
    get isWalletConnect() {
        return true;
    }
    _eth_accounts() {
        return [...this._addresses];
    }
    _net_version() {
        return 8217;
    }
    _eth_chainId() {
        return this.getChainId();
    }
    _personal_sign(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const bappName = this.bappName;
                const value = typeof params[0] === 'string' ? params[0] : 'undefined'; //message
                const from = params[1];
                const res = yield prepare.signMessage({
                    bappName,
                    value: (0, utils_1.convertHexToUtf8)(value),
                    from,
                });
                if (res.err) {
                    return reject(res.err);
                }
                else if (res.request_key) {
                    const klipLink = KlipUrl + res.request_key;
                    this.qrcodeModal.open(klipLink, () => {
                        this.emit('modal_closed');
                    });
                    const interval = setInterval(() => {
                        getResult(res.request_key).then((data) => {
                            if (data.status == 'completed') {
                                this.qrcodeModal.close();
                                clearInterval(interval);
                                return resolve({
                                    jsonrpc: '2.0',
                                    id: 0,
                                    result: data.result.signature,
                                });
                            }
                            else if (data.status == 'canceled' || data.status == 'error') {
                                this.qrcodeModal.close();
                                clearInterval(interval);
                                return reject(new Error('Process is canceled or error occurs'));
                            }
                        });
                    }, 1000);
                    this.on('modal_closed', () => {
                        clearInterval(interval);
                        return reject(new Error('QRCode modal is closed!'));
                    });
                }
            }));
        });
    }
    _eth_sendTransaction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            // send token transaction & send klay transaction
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (params[0].hasOwnProperty('data') && params[0]['data'] != '') {
                    return reject(new Error('This provider cannot be used to execute smart contract functions.'));
                }
                const bappName = this.bappName;
                const to = params[0]['to'];
                const amount = (Number(params[0]['value']) * Number(10 ** -18)).toFixed(6).toString();
                const res = yield prepare.sendKLAY({
                    bappName,
                    to,
                    amount,
                });
                if (res.err) {
                    return reject(res.err);
                }
                else if (res.request_key) {
                    const klipLink = KlipUrl + res.request_key;
                    this.qrcodeModal.open(klipLink, () => {
                        this.emit('modal_closed');
                    });
                    const interval = setInterval(() => {
                        getResult(res.request_key).then((data) => {
                            if (data.status == 'completed') {
                                this.qrcodeModal.close();
                                clearInterval(interval);
                                return resolve({
                                    jsonrpc: '2.0',
                                    id: 0,
                                    result: data.result.tx_hash,
                                });
                            }
                            else if (data.status == 'canceled' || data.status == 'error') {
                                this.qrcodeModal.close();
                                clearInterval(interval);
                                return reject(new Error('Process is canceled or error occurs'));
                            }
                        });
                    }, 1000);
                    this.on('modal_closed', () => {
                        clearInterval(interval);
                        return reject(new Error('QRCode modal is closed!'));
                    });
                }
            }));
        });
    }
    _eth_call(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.caver == undefined || !this.caverEnabled) {
                throw new Error(ErrorMsgCaverUndefined);
            }
            const result = yield this.caver.rpc.klay.call(params[0], params[1]);
            return { jsonrpc: '2.0', id: 0, result };
        });
    }
    _personal_ecRecover(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.caver == undefined || !this.caverEnabled) {
                throw new Error(ErrorMsgCaverUndefined);
            }
            const address = yield this.caver.utils.recover(params[0], params[1]);
            return { jsonrpc: '2.0', id: 0, result: address };
        });
    }
    _eth_getTransactionReceipt(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.caver == undefined || !this.caverEnabled) {
                throw new Error(ErrorMsgCaverUndefined);
            }
            const receipt = yield this.caver.rpc.klay.getTransactionReceipt(params[0]);
            return { jsonrpc: '2.0', id: 0, result: receipt };
        });
    }
    _eth_blockNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.caver == undefined || !this.caverEnabled) {
                throw new Error(ErrorMsgCaverUndefined);
            }
            const blockNumber = yield this.caver.rpc.klay.getBlockNumber();
            return { jsonrpc: '2.0', id: 0, result: blockNumber };
        });
    }
    _eth_getBlockByNumber(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.caver == undefined || !this.caverEnabled) {
                throw new Error(ErrorMsgCaverUndefined);
            }
            const block = yield this.caver.rpc.klay.getBlockByNumber(params[0], params[1]);
            return { jsonrpc: '2.0', id: 0, result: block };
        });
    }
    _eth_getGasPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.caver == undefined || !this.caverEnabled) {
                throw new Error(ErrorMsgCaverUndefined);
            }
            const result = yield this.caver.rpc.klay.getGasPrice();
            return { jsonrpc: '2.0', id: 0, result: result };
        });
    }
}
exports.KlipWeb3Provider = KlipWeb3Provider;
